export default [

  // *===============================================---*
  // *--------- USUARIO ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/apps/usuarios/lista',
    name: 'apps-usuarios-lista',
    // eslint-disable-next-line import/extensions
    component: () => import('@/views/App/Usuarios/usuarios-lista/UsersList.vue'),
  },
  {
    path: '/app/webinar-simulator',
    name: 'webinar-simulator',
    component: () => import('@/views/App/WebinarSimulator/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
      action: 'read'
    },
  },
  {
    path: '/auth/callback',
    name: 'YouTubeCallback',
    component: () => import('@/views/auth/YouTubeCallback.vue'),
    meta: {
      title: 'Autenticação YouTube - Callback',
    },
  },
  {
    path: '/apps/users/view/:id',
    name: 'apps-users-view',
    component: () => import('@/views/App/Usuarios/usuarios-view/UsersView.vue'),
  },
  // {
  //   path: '/apps/users/edit/:id',
  //   name: 'apps-users-edit',
  //   component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
  // },
  /*

       -------------------------------------------------------------------------------------------------------
       ------------------------------------------PASTAS-------------------------------------------------------
       -------------------------------------------------------------------------------------------------------
       */

  {
    path: '/testepasta',
    name: 'testepasta',
    component: () => import('@/views/App/Pastas/EditarPasta.vue'),
  },
  {
    path: '/FileComponent',
    name: 'FileComponent',
    component: () => import('@/components/FileComponent.vue'),
  },

  /*
       -------------------------------------------------------------------------------------------------------
       ------------------------------------------VIDEOS-------------------------------------------------------
       -------------------------------------------------------------------------------------------------------
       */

  {
    path: '/Videos',
    name: 'Meus-Videos',
    component: () => import('@/views/App/Videos/MeusVideos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
      typeHelperTour: 'meus-videos',
    },
  },
  {
    path: '/adicionarVideos',
    name: 'adicionar-videos',
    component: () => import('@/views/App/Videos/AdicionarVideos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/Videosdel',
    name: 'adicionar-videos',
    component: () => import('@/views/App/Videos/Videos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /* EDITAR VIDEO */
  {
    path: '/player/:vslId',
    name: 'player',
    component: () => import('@/views/App/Videos/EditarVideo/EditarVideos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /* CUSTOMIZAÇÂO */

  {
    path: '/player/:vslId/customizacao',
    name: 'customizacao',
    component: () => import('@/views/App/Videos/Customizacao/Customizacao.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/player/:vslId/analytics',
    name: 'analytics',
    component: () => import('@/views/App/Videos/EditarVideo/Analytics.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  /*
      -------------------------------------------------------------------------------------------------------
      ------------------------------------------ESTILO-------------------------------------------------------
      -------------------------------------------------------------------------------------------------------
      */

  {
    path: '/player/:vslId/customizacao',
    name: 'estilo',
    component: () => import('@/views/App/Videos/Customizacao/ControleEstilo/Estilo.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/createEstilo',
    name: 'Create-estilo',
    component: () => import('@/views/App/Videos/Customizacao/ControleEstilo/CreateEstilo.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------THUMBNAILS---------------------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/thumbnails',
    name: 'thumbnails',
    component: () => import('@/views/App/Videos/Customizacao/thumb/ThumbNails.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/createthumb/:thumbId',
    name: 'thumbnails',
    component: () => import('@/views/App/Videos/Customizacao/thumb/CreateThumb.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  //  {
  //    path: '/thumbnailsInicio',
  //    name: 'thumbnails',
  //    component: () =>import ('@/views/App/Videos/Customizacao/thumb/upload/ThumbnailInicio.vue'),

  //  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------AUTO PLAY HIBRIDO--------------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/AutoPlayHibrido',
    name: 'AutoPlay-Hibrido',
    component: () => import(
      '@/views/App/Videos/Customizacao/Auto-Play-Hibrido/AutoPlayHibrido.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/AutoPlayHibridoCreate',
    name: 'Create-AutoPlay-Hibrido',
    component: () => import(
      '@/views/App/Videos/Customizacao/Auto-Play-Hibrido/CreateAutoPlay.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------CONTINUAR ASSISTINDO ----------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/ContinuarAssistindo',
    name: 'Continuar-Assistindo',
    component: () => import(
      '@/views/App/Videos/Customizacao/Continuaar-Assistindo/ContinuarAssitindo.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/CreateContinuarAssistindo',
    name: 'Create-Continuar-Assistindo',
    component: () => import(
      '@/views/App/Videos/Customizacao/Continuaar-Assistindo/CreateContinuarAssistindo.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------PROGRESSO INTELIGENTE----------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/ProgressoInteligente',
    name: 'Progresso-Inteligente',
    component: () => import(
      '@/views/App/Videos/Customizacao/Progrsso-Inteligente/ProgressoInteligente.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/CreateProgresso',
    name: 'Create-Progresso-Inteligente',
    component: () => import(
      '@/views/App/Videos/Customizacao/Progrsso-Inteligente/CreateProgressoInteligente.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  {
    path: '/Routerteste',
    name: 'Progresso-Inteligente',
    component: () => import('@/views/App/Videos/EditarVideo/Editar.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
      -------------------------------------------------------------------------------------------------------
      ------------------------------------------ BOTÕES DE AÇÕES -------------------------------------------
      -------------------------------------------------------------------------------------------------------
    */
  {
    path: '/player/:vslId/botoes-acoes',
    name: 'botoes-acoes',
    component: () => import('@/views/App/Videos/Customizacao/Botoes-&-Acoes/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  /* SEGURANÇA */
  {
    path: '/seguranca',
    name: 'Seguranca',
    component: () => import('@/views/App/Seguranca/Seguranca.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      pageTitle: 'Segurança',
      requiresAuth: true,
    },
  },

  /* TESTE A/B */

  {
    path: '/teste-ab',
    name: 'teste-ab',
    component: () => import('@/views/App/testesAB/TestesAb.vue'),
    meta: {
      pageTitle: 'Teste A/B',
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*  DASHABOARD */

  {
    path: '/dashboard',
    name: 'DashboardVsl',
    component: () => import('@/views/App/Dashboard/DashboardStart.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },

  },
  /* CHAT */

  {
    path: '/fluxoMensagem/:id',
    name: 'fluxo',
    component: () => import('@/views/App/Chat/FluxoMensagem.vue'),
    meta: {
      pageTitle: 'Fluxo Perguntas',
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/chats',
    name: 'chats',
    component: () => import('@/views/App/Chat/Index.vue'),
    meta: {
      requiresAuth: true,
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
    },
  },
  {
    path: '/dashboardChat',
    name: 'DashboardChat',
    component: () => import('@/views/App/Dashboard/DashbordChat.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/teste',
    name: 'teste',
    component: () => import('@/views/App/Chat/Teste.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/design/:id',
    name: 'design',
    component: () => import('@/views/App/Chat/design.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/editCurso/:id',
    name: 'dadosCurso',
    component: () => import('@/views/App/Cursos/EditCurso.vue'),
    meta: {
      resource: 'EDITCURSO',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/integreSistema/:id',
    name: 'integreSistema',
    component: () => import('@/views/App/Chat/integreSistema.vue'),
    meta: {
      resource: 'IntegreSistema',
      action: 'integreSistema',
      requiresAuth: true,
    },
  },
  {
    path: '/leads',
    name: 'leads',
    component: () => import('@/views/App/Chat/Leads.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/detalhelead/:id_lead',
    name: 'Detalheleads',
    component: () => import('@/views/App/Chat/detalheLead.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('@/views/App/Chat/Info.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  /* CURSOS (AREA ALUNO) */

  {
    path: '/courses',
    name: 'courses',
    component: () => import('@/views/App/Cursos/AreaAluno/MeusCursos.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },

  },
  {
    path: '/course/:id',
    name: 'viewCurso',
    component: () => import('@/views/App/Cursos/AreaAluno/ViewCurso.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },
  },
  {
    path: '/addConteudo',
    name: 'addConteudo',
    component: () => import('@/views/App/Cursos/CreateConteudo.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },
  },

  {
    path: '/editConteudo',
    name: 'editConteudo',
    component: () => import('@/views/App/Cursos/EditConteudo.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },
  },
  /* TREINAMENTOS */

  {
    path: '/treinamentos/chat-booster/:id?',
    name: 'treinamentos-chatbooster',
    component: () => import('@/views/App/Treinamentos/TreinamentosChatBooster.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },

  },

  {
    path: '/treinamentos/vsl-booster/:id?',
    name: 'treinamentos-vslbooster',
    component: () => import('@/views/App/Treinamentos/TreinamentosVslBooster.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },

  },

  {
    path: '/adminTreinamentos',
    name: 'adminTreinamentos',
    component: () => import('@/views/App/Treinamentos/TreinamentosAdmin/AdminTreinamento.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },
  {
    path: '/cliTreinamentos',
    name: 'cliTreinamentos',
    component: () => import('@/views/App/Cursos/Cursos.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },
  {
    path: '/staticsCurso/:id',
    name: 'staticsCurso',
    component: () => import('@/views/App/Cursos/EstatisticasCurso.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },
  },
  {
    path: '/cadAluno',
    name: 'cadAluno',
    component: () => import('@/views/App/Cursos/CadAlunos.vue'),
    meta: {
      resource: 'CURSOS',
      action: 'read',
    },
  },
  {
    path: '/editAluno/:id',
    name: 'editAluno',
    component: () => import('@/views/App/Cursos/EditAlunos.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },
  /* CONTEUDO */

  {
    path: '/CriarConteudo',
    name: 'admin-CriarConteudo',
    component: () => import('@/views/App/Treinamentos/TreinamentosAdmin/CriarConteudo.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },

  {
    path: '/editarConteudo',
    name: 'editarConteudo',
    component: () => import('@/views/App/Treinamentos/TreinamentosAdmin/EditarConteudo.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },

  /**
     * Rotas Tour Virtual
     */
  {
    path: '/tour-virtual',
    name: 'tour-virtual',
    component: () => import('@/views/App/TourVirtual/Index.vue'),
    meta: {
      resource: 'TOUR_VIRTUAL',
      action: 'manage',
    },
  },
  /**
   * Rotas Pagementos
   */
  {
    path: '/pagamentos',
    name: 'pagamentos',
    component: () => import('@/views/App/Pagamentos/Index.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },

  /**
   * Rota de Checkout Payments
   */
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/App/PaymentView/Index.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/payment/pix',
    name: 'payment-pix',
    component: () => import('@/views/App/PaymentView/ConfirmePixView.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/payment/boleto',
    name: 'payment-boleto',
    component: () => import('@/views/App/PaymentView/ConfirmeBoletoView.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/notificacoes',
    name: 'all-notifications',
    component: () => import('@/views/App/Notificação/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  {
    path: '/auth/login/usuario-cliente',
    name: 'auth-login-usuario-cliente',
    component: () => import('@/views/Login/LoginAdminDKP.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
      layout: 'full',
      requiresAuth: true,
    },
  },
]
